export async function getList({commit}, page) {

  const {errResponse, data: responseData} = await this.$adminRepositories.plans.index(page);

  if (!errResponse && responseData.success) {
    return commit('setList', responseData.data);
  }

  return [];
}

export async function getPublicPlans({commit}, page) {

  const {errResponse, data: responseData} = await this.$adminRepositories.plans.getPublicPlans(page);

  if (!errResponse && responseData.success) {
    return commit('setList', responseData.data);
  }

  return responseData;
}

export async function deletePlanById({commit}, payload) {
  const response = await this.$adminRepositories.plans.delete(payload.id);
  await commit('removeItem', payload.index);
  return response;
}

export async function createPlan({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.plans.create(payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function updatePlan({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.plans.update(payload.id, payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function findPlanById({commit}, payload) {
  return await this.$adminRepositories.plans.show(payload);
}
